module.exports = __webpack_public_path__ + "6904fcf9cfb81807e0bcfe890c46f7c1.svg";